import { useState } from 'react';
import { Collapse, cn } from '@divlab/divanui';
import { IconChevronBottom } from '@divlab/divanui/icons';

import styles from './CollapsableTableItem.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { MobileTableItem } from '@Modals/DeliveryAndAssemblyModal/DeliveryAndAssemblyModal';

interface CollapsableTableItemProps extends HTMLAttributes<HTMLDivElement> {
  item: MobileTableItem;
}

const CollapsableTableItem: FC<CollapsableTableItemProps> = (props) => {
  const { item, className, ...restProps } = props;
  const { group, rows } = item;
  const [collapsed, setCollapsed] = useState(true);

  const handleClick = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div {...restProps} className={className}>
      <div className={styles.wrapperLabel} onClick={handleClick}>
        <span>{group}</span>
        <div className={cn(styles.iconArrow, { [styles.expanded]: !collapsed })}>
          <IconChevronBottom />
        </div>
      </div>
      <Collapse collapsed={collapsed}>
        <div className={styles.termsContainer}>
          {rows.map((row) => (
            <div key={row.term} className={styles.term}>
              <div className={styles.title}>{row.term}</div>
              <div>{row.price}</div>
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

export default CollapsableTableItem;
